module.exports = __webpack_public_path__ + "static/media/warning-alert.0909c299.svg";